import './listeners_sort';
import './listeners_categories';
import './listeners_sidebars';
import './listeners_in_stock';
import './listeners_scrollloading';
import {onReady} from "../../../../../modules/vegas/js/util";
import CatalogProduct from "./catalogProduct";

window.addEventListener('popstate', function(event) {
	if (event.state?.reload === true) {
		location.reload();
	}
});

onReady(() => {
	document.querySelectorAll('[data-product]').forEach((element) => {
		new CatalogProduct().init(element);
	});
});
